export default __webpack_public_path__ + "static/media/uk.476f4df1.jpg";